var store      = require('./_shared')('wks')
  , uid        = require('./_uid')
  , Symbol     = require('./_global').Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/~/core-js/modules/_wks.js
// module id = ../../../../core-js/modules/_wks.js
// module chunks = 0